import React, { useState, useMemo, useContext } from 'react';
import DialogComp from '../../../../Core/Modal/dialogModal';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import AppContext from '../../../../App/AppContext';
import ManageAccountGrid from '../../../managementAccount/manageAccountGrid/index';
import { Grid } from '@material-ui/core';
import ReactDOM from 'react-dom';
import AccountLinkModal from './AccountLinkModal';
import formatters from '../../../../Core/Grid/inputFormatter';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Management Accounts', active: true },
    { name: 'Nominal Accounts Unmapped', active: true }
];
const basecolumns = [
    { field: 'accountCode', title: 'Account Code', width: 70 },
    { field: 'en', title: 'Description', width: 100 },
    { field: 'balance', title: 'Balance', width: 80, renderer: formatters.CurrencyThousandSeparator },
    { field: 'branch', title: 'Branch', width: 40 },
    { field: 'branchName', title: 'Branch Name', width: 100 },
    { field: 'department', title: 'Department', width: 40 },
    { field: 'departmentName', title: 'Department Name', width: 100 },
    { field: 'model', title: 'Model', width: 40 },
    { field: 'modelName', title: 'Model Name', width: 80 }
];
const NominalAccountsUnmapped = () => {
    const [state, setState] = useState({
        open: false,
        showLoader: true,
        selectedRowData: {}
    });
    const [modalOpen, setModalOpen] = useState(false);
    const [AccountCode, setAccountCode] = useState(null);
    const [reloadGrid, setReloadGrid] = useState(false);
    const { showToast } = useContext(AppContext);

    const handleCloseModal = (shouldReload = false) => {
        setModalOpen(false);
        if (shouldReload) {
            setReloadGrid((prev) => !prev);
        }
    };
    const handleOpenModal = async (rowData) => {
        setAccountCode(rowData.accountCode);
        setModalOpen(true);
        setState((prev) => ({
            ...prev,
            selectedRowData: rowData
        }));
    };

    const AccountCodeColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => handleOpenModal(record)}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let accountCode = tempCols.find((m) => m.field === 'accountCode');
        if (accountCode.field) {
            accountCode.renderer = AccountCodeColumnWrapper;
        }
        return tempCols;
    }, []);

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <ManageAccountGrid
                columns={columns}
                getUrl={`NominalCodes/MANominalAccountCodes_NotMapped`}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={reloadGrid}
            />
            {modalOpen ? (
                <DialogComp onClose={handleCloseModal} title={'Link Account Code'} maxWidth="md">
                    <AccountLinkModal onClose={handleCloseModal} accountCode={AccountCode} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default NominalAccountsUnmapped;
